import { render, staticRenderFns } from "./SetUninstall.vue?vue&type=template&id=de5091f2"
import script from "./SetUninstall.vue?vue&type=script&lang=js"
export * from "./SetUninstall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports